import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Headless Universal Checkout Specific Errors`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Recovery Suggestion`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`huc-initialization-failed`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when Headless Universal Checkout failed to initialize during the `}<a parentName="td" {...{
              "href": "./../../primerHeadlessUniversalCheckout/start"
            }}>{`start`}</a>{` call.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ensure you are calling `}<inlineCode parentName="td">{`start`}</inlineCode>{` method before calling this method.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-raw-type-data`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the wrong data type is being passed to the `}<a parentName="td" {...{
              "href": "./../../primerHeadlessUniversalCheckout/rawDataManager/rawDataManagerSetRawData"
            }}>{`setRawData`}</a>{` method.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify the data type being passed and correct it.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-raw-data`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the `}<a parentName="td" {...{
              "href": "./../../primerHeadlessUniversalCheckout/rawDataManager/rawDataManagerSubmit"
            }}>{`submit`}</a>{` method was called without a prior call to the `}<a parentName="td" {...{
              "href": "./../../primerHeadlessUniversalCheckout/rawDataManager/rawDataManagerSetRawData"
            }}>{`setRawData`}</a>{` method.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ensure `}<inlineCode parentName="td">{`setRawData`}</inlineCode>{` is called with valid data before calling `}<inlineCode parentName="td">{`submit`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      